// Client-side engine-bridge state (Phase 5 Step 12 — consolidate-state core).
//
// Held as an OBJECT whose PROPERTIES are mutated (same rationale as src/state.js): property writes cross
// ES-module boundaries AND preserve reference identity. That identity is load-bearing here — these values
// are pushed BY REFERENCE into the scoring engine via `setEngineContext` (lib/engine.js), and
// `lastMarketStructure` is additionally mutated IN PLACE (`.rsThrustTrend`) after the push, so the engine's
// shared reference sees the change without a re-push. Moving these off module-level `let`s onto this object
// keeps that identity intact (reassigning an imported `let` would not cross the boundary at all).
//
// rsUniverseDistribution's browser-storage hydrate/persist stays in the app.js SHELL (PORT-1 deferred), so
// this module has ZERO browser globals — it is portable core.
export const engineState = {
    cachedDataResults: [],        // raw {t,o,h,l,c,v} bars for the loaded ticker (shared by-ref with the engine)
    lastMarketStructure: null,    // market-structure verdict; pushed by-ref to engine + mutated in-place (.rsThrustTrend)
    omegaSignals: [],             // channel/Omega markers for the loaded ticker (pulled back from the engine per ticker)
    rsUniverseDistribution: null, // RS percentile universe (array); its persistence lives in the app.js shell (PORT-1)
};
